import axios from "axios";

// In-browser: always call the same origin. This makes the app portable across
// the preview host, the default deployed host, and any attached custom domain
// (e.g. konzenzo.com) without rebuilding. Emergent's ingress routes /api to the
// backend on every served domain, and keeping calls same-origin also keeps
// the session_token cookie in a first-party context.
const BACKEND_URL = typeof window !== "undefined" && window.location?.origin
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
